import CLIENT from '../actionTypes';

import { AppAction } from '../../../types/app';
import { ClientTotalBalanceState } from '../types';

const initialState: ClientTotalBalanceState = {
  balance: null,
  updateTime: 0,
  readyStatus: CLIENT.TOTAL_BALANCE.INVALID,
  err: null,
};

export default (
  state: ClientTotalBalanceState = initialState,
  action: AppAction = {}
): ClientTotalBalanceState => {
  switch (action.type) {
    case CLIENT.TOTAL_BALANCE.REQUESTING:
      return {
        ...state,
        err: null,
        readyStatus: action.type,
      };
    case CLIENT.TOTAL_BALANCE.FAILURE:
      return {
        ...state,
        readyStatus: action.type,
        err: action.err,
      };
    case CLIENT.TOTAL_BALANCE.SUCCESS:
      return {
        ...state,
        err: null,
        readyStatus: action.type,
        balance: action.data,
        updateTime: Date.now(),
      };
    default:
      return state;
  }
};
